import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Product, Pagination } from "services/productService";

export interface ProductState {
  products: Product[];
  pagination: Pagination | null;
  loading: boolean;
  error: string | null;
}

export const initialState: ProductState = {
  products: [],
  pagination: null,
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProductLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setProductData(
      state,
      action: PayloadAction<{ products: Product[]; pagination: Pagination }>
    ) {
      state.products = action.payload.products;
      state.pagination = action.payload.pagination;
      state.error = null;
    },
    setProductError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setProductLoading,
  setProductData,
  setProductError,
} = productSlice.actions;

export default productSlice.reducer;

